module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "title": "Déplacement d'une fiche",
      "visible": _vm.visible,
      "close-on-click-modal": false,
      "width": "30%"
    },
    on: {
      "update:visible": function($event) {
        _vm.visible = $event
      }
    }
  }, [_c('div', [_c('p', [_vm._v("\n      Vous êtes sur le point d'effectuer le déplacement suivant :\n    ")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Déplacement de la fiche : "), _c('customer', {
    attrs: {
      "item": _vm.from
    }
  })], 1), _vm._v(" "), _c('li', [_vm._v("Dans la fiche : "), _c('customer', {
    attrs: {
      "item": _vm.into
    }
  })], 1)]), _vm._v(" "), _c('p', [_vm._v("Vous pouvez soit : ")]), _vm._v(" "), _c('ul', [_c('li', [_c('strong', [_vm._v("Fusionner les fiches")]), _vm._v(" : La fiche déplacée sera supprimée et tout son contenu (rappels,\n        commentaires, services etc ...) appartiendra à la fiche de destination.")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Définir comme fiche fille")]), _vm._v(" : La fiche déplacée sera indiquée comme fille de la fiche de\n        destination.")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "warning"
    },
    on: {
      "click": function($event) {
        return _vm.merge()
      }
    }
  }, [_vm._v("Fusionner les fiches ...")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.move()
      }
    }
  }, [_vm._v("Définir comme fiche fille")])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-646f0a3c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./libs/@db2b/keystone/components/Modals/MoveCustomersModal.vue
// module id = 701
// module chunks = 1